export default __webpack_public_path__ + "static/media/Image.f7abce8c.png";